import { LogOut, Ban, ClipboardList, User } from "lucide-react";
import { Button, type SelectChangeEvent } from "@mui/material";
import React, { useState } from "react";
import dayjs from "dayjs";
import { ApiPutShopperDetails } from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";

const Dcrage = ({ loanData, handleClose }) => {
  const [shopperNotes, setShopperNotes] = useState(loanData?.shopperOtherDetail?.shopperNotes || "");
  const [trainingNotes, setTrainingNotes] = useState(loanData?.shopperOtherDetail?.trainingNotes || "");

  console.log(loanData);
  const getTimeSinceCreated = (createdOn: string): string => {
    if (!createdOn) return "N/A";

    const createdDate = new Date(createdOn);
    const now = new Date();

    const diffYears = now.getFullYear() - createdDate.getFullYear();
    const diffMonths =
      (now.getFullYear() - createdDate.getFullYear()) * 12 +
      (now.getMonth() - createdDate.getMonth());

    if (diffYears >= 1) {
      return `${diffYears} year${diffYears > 1 ? "s" : ""} ago`;
    } else if (diffMonths >= 1) {
      return `${diffMonths} month${diffMonths > 1 ? "s" : ""} ago`;
    } else {
      return "Less than a month ago";
    }
  };

  const formatDate = (dateString: string): string => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const saveShopperNotes = async (userId: any) => {
    try {
      const data = {
        userId: userId,
        shopperNotes: shopperNotes,
      };
      const response = ApiPutShopperDetails(data);

      toast.success("Shopper notes saved successfully");
    } catch (error) {
      console.error("Error saving shopper notes:", error);
      toast.error("Error saving shopper notes");
    }
  };

  const saveTrainingNotes = async (userId: any) => {
    try {
      const data = {
        userId: userId,
        trainingNotes: trainingNotes,
      };
      const response = ApiPutShopperDetails(data);
      toast.success("Training notes saved successfully");
    } catch (error) {
      console.error("Error saving training notes:", error);
      toast.error("Error saving training notes");
    }
  };

  return (
    <div className="loanData-model" onMouseLeave={handleClose}>
      <div className="profile-container">
        <div className="profile-card">
          <div className="profile-header">
            <div className="profile-title">
              <h2>
                {loanData?.firstName} {loanData?.lastName}{" "}
              </h2>
              {/* <span className='status-badge'>Incomplete Profile</span> */}
            </div>
            <hr></hr>
            <div className="action-buttons">
              <Button className="icon-button table-row-background">
                <LogOut size={20} color="white" />
              </Button>
              <Button className="icon-button table-row-background">
                <Ban size={20} color="white" />
              </Button>
              <Button className="icon-button table-row-background">
                <ClipboardList size={20} color="white" />
              </Button>
              <Button className="icon-button table-row-background">
                <User size={20} color="white" />
              </Button>
            </div>
          </div>
          <h5>Contact Details:</h5>
          <div className="contact-details table-row-background">
            <div className="contact-item">
              <div className="label">Age:</div>
              <div className="value">
                {dayjs().diff(dayjs(loanData?.dob), "year")}{" "}
              </div>
            </div>
            <div className="contact-item">
              <div className="label">Email:</div>
              <div className="value">{loanData?.emailId}</div>
            </div>
            <div className="contact-item">
              <div className="label">Phone:</div>
              <div className="value">{loanData?.contactNo}</div>
            </div>
          </div>
          <hr></hr>
          <div className="allocations-section ">
            <h3>This month allocations</h3>
            <div className="allocations-grid min-border-color">
              <table>
                <thead className="table-row-background">
                  {[
                    { label: "MM", key: "MM" },
                    { label: "ALDI", key: "ALDI" },
                    { label: "BLOOMS", key: "BLOOMS" },
                    { label: "Transport", key: "Transport" },
                  ].map((header) => (
                    <th>{header.label}</th>
                  ))}
                </thead>
                <tbody>
                  <td>{loanData?.currentMonthAllocationCounts?.MM || 0}</td>
                  <td>{loanData?.currentMonthAllocationCounts?.ALDI || 0}</td>
                  <td>{loanData?.currentMonthAllocationCounts?.BLOOMS || 0}</td>
                  <td>
                    {loanData?.currentMonthAllocationCounts?.TRANSPORT || 0}
                  </td>
                </tbody>
              </table>
            </div>
          </div>
          <hr></hr>
          <div className="history-section">
            <h5>Shopper History:</h5>
            <div className="reports-card table-row-background">
              <div className="reports-vs">
                <div className="reports-total">
                  {loanData?.totalReportCounts?.total || 0} Reports
                </div>
                <div className="reports-grid">
                  <div className="allocations-grid min-border-color">
                    <table>
                      <thead className="table-row-background">
                        {["ALDI", "BLOOMS", "MM", "TRANSPORT"].map((header) => (
                          <th>{header}</th>
                        ))}
                      </thead>
                      <tbody>
                        <td>{loanData?.totalReportCounts?.ALDI}</td>
                        <td>{loanData?.totalReportCounts?.BLOOMS}</td>
                        <td>{loanData?.totalReportCounts?.MM}</td>
                        <td>{loanData?.totalReportCounts?.TRANSPORT}</td>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="member-since">
                <div className="label">Member Since:</div>
                <div className="value">
                  {getTimeSinceCreated(loanData?.createdOn)}
                </div>
              </div>
              <div className="member-since">
                <div className="label">Last Report Rating:</div>
                <div className="value">
                  <div>
                    {loanData?.lastReportRatingData?.MM?.reportCreatedDate
                      ? `MM -- ${
                          loanData.lastReportRatingData.MM.reportMonth
                        }/${
                          loanData.lastReportRatingData.MM.reportYear
                        } -- ${formatDate(
                          loanData.lastReportRatingData.MM.submitDate
                        )} -- ${loanData.lastReportRatingData.MM.score}/100`
                      : "MM -- N/A"}
                  </div>
                  <div>
                    {loanData?.lastReportRatingData?.ALDI?.reportCreatedDate
                      ? `ALDI -- ${
                          loanData.lastReportRatingData.ALDI.reportMonth
                        }/${
                          loanData.lastReportRatingData.ALDI.reportYear
                        } -- ${formatDate(
                          loanData.lastReportRatingData.ALDI.submitDate
                        )} -- ${loanData.lastReportRatingData.ALDI.score}/100`
                      : "ALDI -- N/A"}
                  </div>
                  <div>
                    {loanData?.lastReportRatingData?.BLOOMS?.reportCreatedDate
                      ? `BLOOMS -- ${
                          loanData.lastReportRatingData.BLOOMS.reportMonth
                        }/${
                          loanData.lastReportRatingData.BLOOMS.reportYear
                        } -- ${formatDate(
                          loanData.lastReportRatingData.BLOOMS.submitDate
                        )} -- ${loanData.lastReportRatingData.BLOOMS.score}/100`
                      : "BLOOMS -- N/A"}
                  </div>
                </div>
              </div>
              <div className="member-since">
                <div className="label">Last Month:</div>
                <div className="value">
                  {`${loanData?.totalReportCounts?.totalLastMonthReportCounts} Reports` ||
                    "0 Reports"}
                </div>
              </div>
              <div className="member-since">
                <div className="label">Overall Rating:</div>
                <div className="value">
                  {loanData?.shopperOverAllRating || "N/A"}
                </div>
              </div>
              <div className="member-since">
                <div className="label">Editors comment:</div>
                <div className="value">
                  {[
                    loanData?.lastReportRatingData?.MM,
                    loanData?.lastReportRatingData?.ALDI,
                    loanData?.lastReportRatingData?.BLOOMS,
                  ]
                    .filter((r) => r?.submitDate)
                    .sort(
                      (a, b) =>
                        new Date(b.submitDate).getTime() -
                        new Date(a.submitDate).getTime()
                    )[0]?.editorComment || "No comments available"}
                </div>
              </div>
            </div>
          </div>
          <div className="notes-section ">
            <div className="notes-container  min-border-color">
              <h3 className="table-row-background">Shopper Notes</h3>{" "}
              <div style={{ padding: "10px" }}>
                <textarea
                  placeholder="Enter shopper notes..."
                  value={shopperNotes}
                  onChange={(e) => setShopperNotes(e.target.value)}
                />
                <Button
                  className="save-button table-row-background"
                  onClick={() => saveShopperNotes(loanData.userId)}
                >
                  Save shopper notes
                </Button>
              </div>
            </div>
            <div className="notes-container  min-border-color">
              <h3 className="table-row-background">Training Notes</h3>{" "}
              <div style={{ padding: "10px" }}>
                <textarea
                  placeholder="Enter training notes..."
                  value={trainingNotes}
                  onChange={(e) => setTrainingNotes(e.target.value)}
                />
                <Button
                  className="save-button table-row-background"
                  onClick={() => saveTrainingNotes(loanData.userId)}
                >
                  Save training notes
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dcrage;
